// extracted by mini-css-extract-plugin
module.exports = {"outerClass":"NetWorth_outerClass__2u4kO","header":"NetWorth_header__2kCDP","headTag":"NetWorth_headTag__3f36s","amtTag":"NetWorth_amtTag__2jhJz","center":"NetWorth_center__SMwdy"};